import { ButtonSize, ButtonStyle } from "./Button.types";

const baseClassNames = "inline-flex items-center justify-center border border-solid font-medium no-underline";
const disabledClassNames =
    "disabled:opacity-80 disabled:cursor-not-allowed disabled:ring-transparent disabled:border-gray-200 disabled:bg-neutral-100 disabled:text-gray-600";
const commonStyleClassNames = "focus:outline-none focus:ring-2";

function classNamesBySize(size: ButtonSize) {
    const specificClassNames = {
        [ButtonSize.ExtraSmall]: "rounded px-2.5 py-1.5 text-xs",
        [ButtonSize.Small]: "rounded-md px-3 py-2 text-sm leading-4",
        [ButtonSize.Medium]: "rounded-md px-4 py-2 text-sm",
        [ButtonSize.Large]: "rounded-md px-4 py-2 text-base",
        [ButtonSize.ExtraLarge]: "rounded-md px-6 py-3 text-base",
    }[size];

    return `${baseClassNames} ${specificClassNames}`;
}

function classNamesByStyle(style: ButtonStyle) {
    const specificClassNames = {
        [ButtonStyle.Primary]: "text-white bg-blue-600 hover:bg-blue-700 focus:ring-blue-200",
        [ButtonStyle.PrimaryLink]: "text-blue-600 bg-transparent border-none hover:text-blue-700 focus:ring-blue-200",
        [ButtonStyle.Secondary]:
            "text-gray-900 bg-white border-gray-200 hover:bg-neutral-100 hover:text-blue-700 focus:ring-gray-200",
        [ButtonStyle.SecondaryLink]: "text-gray-600 bg-transparent border-none hover:text-blue-700 focus:ring-gray-200",
        [ButtonStyle.Black]: "text-white bg-neutral-800 hover:bg-neutral-900 focus:ring-gray-300",
        [ButtonStyle.Green]: "text-white bg-green-600 hover:bg-green-700 focus:ring-green-300",
        [ButtonStyle.Yellow]: "text-white bg-yellow-600 hover:bg-yellow-700 focus:ring-yellow-300",
        [ButtonStyle.Red]: "text-white bg-red-600 hover:bg-red-700 focus:ring-red-300",
    }[style];

    return `${specificClassNames} ${commonStyleClassNames}`;
}

export const classNamesBySizeAndStyle = (size: ButtonSize, style: ButtonStyle) => {
    return `${classNamesBySize(size)} ${classNamesByStyle(style)} ${disabledClassNames}`;
};
